import { Component, Input, OnInit } from '@angular/core';
import { MainService } from '../../../core/services/main.service';
import { TranslocoService } from '@jsverse/transloco';
import { BagItem, Product } from '../../../core/models';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { PricePipe } from './../../../core/pipes/price.pipe';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-crate-item',
	standalone: true,
	imports: [TranslocoCurrencyPipe, PricePipe, RouterLink],
    templateUrl: './crate-item.component.html',
    styleUrls: ['./crate-item.component.css'],
})
export class CrateItemComponent implements OnInit {

	constructor(
		private mainService: MainService,
		public translate: TranslocoService
	) { }
	@Input() item: BagItem;
	@Input() disableDecrement: boolean;

	// @Input() showDecrementControl = true
	// @Input() showIncrementControl = true
	showDecrementControl = true;
	showIncrementControl = true;
	isLoading: boolean = false;

	ngOnInit(): void {
	}

	incrementItem(item) {
		this.isLoading = true;
		this.mainService.incrementItem(this.mainService.crate, item).subscribe(_ => this.isLoading = false);
	}

	decrementItem(item) {
		this.isLoading = true;
		this.mainService.decrementItem(this.mainService.crate, item).subscribe(_ => this.isLoading = false);
	}

	isIncrementDisabled() {
		return this.isLoading;
	}

	isDecrementDisabled(item: BagItem) {
		return this.isLoading || (item.quantity <= 1 && this.disableDecrement);
	}
}
